import { MenuItem, IconButton } from "@mui/material";
import MultiSelectCell from "./MultiSelectCell";
import { Notes, itpFuncs, itpProcedures, ndeProcedures } from "./utils";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ChatIcon from "@mui/icons-material/Chat";
import PostAddIcon from "@mui/icons-material/PostAdd";

export const itpColumns = [
  {
    accessorKey: "inspectionTestActivities",
    header: "Inspection / Test Activities",
  },
  {
    accessorKey: "rev",
    header: "rev",
    //  size: 10,
  },
  {
    accessorKey: "procedureNo",
    header: `Procedure No.`,
    muiEditTextFieldProps: ({ cell }) => {
      const safeValue = Array.isArray(cell?.getValue?.())
        ? cell.getValue()
        : [];

      return {
        select: true,
        value: safeValue,
        children: ndeProcedures.map((func) => (
          <MenuItem key={func} value={func}>
            {func}
          </MenuItem>
        )),
        SelectProps: {
          multiple: true,
          renderValue: (selected) =>
            Array.isArray(selected) ? selected.join(", ") : "",
        },
      };
    },
    enableEditing: true,
  },
  {
    accessorKey: "specificInstruction",
    header: "Specific Instruction",
    muiEditTextFieldProps: () => ({
      children: Notes.map((n) => (
        <MenuItem key={n} value={n}>
          {n}
        </MenuItem>
      )),
      select: true,
    }),
    enableEditing: true,
  },
  {
    accessorKey: "authorizedInspectionDate",
    header: "Start Date",
    muiEditTextFieldProps: {
      type: "date",
    },
  },
  {
    accessorKey: "representativeDate",
    header: "End Date",
    muiEditTextFieldProps: {
      type: "date",
    },
  },
  {
    accessorKey: "progress",
    header: "Progress",
    muiEditTextFieldProps: {
      type: "number",
    },
  },
  {
    accessorKey: "actualHours",
    header: "Actual-hours",
    muiEditTextFieldProps: {
      type: "number",
    },
  },
  {
    accessorKey: "timesheet",
    header: `Timesheet`,
    enableEditing: false,
    enableSorting: false,
    enableColumnFilter: false,
    Header: () => <PostAddIcon />,
    Cell: ({ row }) => (
      <IconButton
      // onClick={() => handleButtonClick("timesheet", row)}
      >
        <PostAddIcon />
      </IconButton>
    ),
  },
  {
    id: "Authorized Inspector",
    header: "Authorized Inspector",
    columns: [
      {
        accessorKey: "authorizedInspectionFunc",
        header: "*",
        muiEditTextFieldProps: () => ({
          children: itpFuncs.map((func) => (
            <MenuItem key={func} value={func}>
              {func}
            </MenuItem>
          )),
          select: true,
        }),
      },
      {
        accessorKey: "authorizedInspectionInitials",
        header: "Initials",
      },
    ],
  },
  {
    accessorKey: "Customer Representative",
    header: "Customer Representative",
    columns: [
      {
        accessorKey: "representativeFunc",
        header: "*",
        muiEditTextFieldProps: () => ({
          children: itpFuncs.map((func) => (
            <MenuItem key={func} value={func}>
              {func}
            </MenuItem>
          )),
          select: true,
        }),
      },
      {
        accessorKey: "representativeInitials",
        header: "Initials",
      },
    ],
  },
  {
    accessorKey: "CDT Quality",
    header: "CDT Quality",
    columns: [
      {
        accessorKey: "cdtFunc",
        header: "*",
        muiEditTextFieldProps: () => ({
          children: itpFuncs.map((func) => (
            <MenuItem key={func} value={func}>
              {func}
            </MenuItem>
          )),
          select: true,
        }),
      },
      {
        accessorKey: "cdtInitials",
        header: "Initials",
      },
    ],
  },
  {
    accessorKey: "chat",
    header: "chat",
    Header: () => <ChatIcon />,
    muiTableBodyCellProps: {
      align: "center",
    },
    enableEditing: false,
    enableColumnFilter: false,
    Cell: ({ row }) => (
      <IconButton>
        <ChatIcon />
      </IconButton>
    ),
  },
  {
    accessorKey: "upload",
    header: "doc upload",
    Header: () => <CloudUploadIcon />,
    muiTableBodyCellProps: {
      align: "center",
      wordWrap: "break-word",
    },
    enableEditing: false,
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ row }) => (
      <IconButton>
        <CloudUploadIcon />
      </IconButton>
    ),
  },
];

export const BASE_SCHEMA = [
  {
    key: "number",
    header: "No.",
    fieldType: "text",
    size: 25,
  },
  {
    key: "inspectionTestActivity",
    header: "INSPECTION/TEST ACTIVITY",
    fieldType: "select",
    optionsKey: "INSPECTION/TEST ACTIVITY",
    size: 75,
  },
  {
    key: "rev",
    header: "rev",
    fieldType: "text",
    size: 30,
  },
  {
    key: "controllingDocument",
    header: "CONTROLLING DOCUMENT",
    fieldType: "select",
    optionsKey: "CONTROLLING DOCUMENT",
    size: 50,
  },
  {
    key: "resPartyLocation",
    header: "Res. Party/Loc",
    fieldType: "select",
    optionsKey: "Res. Party/ Location",
    size: 50,
  },
  {
    key: "acceptanceCriteria",
    header: "ACCEPTANCE CRITERIA",
    fieldType: "select",
    optionsKey: "ACCEPTANCE CRITERIA",
    size: 50,
  },
  {
    key: "recordingDocument",
    header: "RECORDING DOCUMENT",
    fieldType: "select",
    optionsKey: "RECORDING DOCUMENT",
    size: 50,
  },
  { key: "startDate", header: "Start Date", fieldType: "date", size: 50 },
  { key: "endDate", header: "End Date", fieldType: "date", size: 50 },
  {
    key: "progress",
    header: "Progress",
    fieldType: "text",
    size: 50,
  },
  {
    key: "actualHours",
    header: "Actual Hrs",
    fieldType: "text",
    size: 30,
  },
  {
    key: "timesheet",
    header: "timesheet",
    fieldType: "icon",
    Header: () => <PostAddIcon />,
    Cell: ({ row }) => (
      <IconButton>
        <PostAddIcon />
      </IconButton>
    ),
    size: 50,
  },
  {
    key: "inspectorType",
    header: "Type",
    fieldType: "select",
    optionsKey: "shopType",
    group: "AUTHORIZED-INSPECTOR",
    size: 50,
  },
  {
    key: "inspectorSign",
    header: "Sign",
    fieldType: "text",
    group: "AUTHORIZED-INSPECTOR",
    size: 50,
  },
  {
    key: "inspectorDate",
    header: "Date",
    fieldType: "date",
    group: "AUTHORIZED-INSPECTOR",
    size: 50,
  },
  {
    key: "shopType",
    header: "Type",
    fieldType: "select",
    optionsKey: "shopType",
    group: "SHOP",
    size: 50,
  },
  {
    key: "shopSign",
    header: "Sign",
    fieldType: "text",
    group: "SHOP",
    size: 50,
  },
  {
    key: "shopDate",
    header: "Date",
    fieldType: "date",
    group: "SHOP",
    size: 50,
  },

  {
    key: "clientType",
    header: "Type",
    fieldType: "select",
    optionsKey: "clientType",
    group: "CLIENT",
    size: 50,
  },
  {
    key: "clientSign",
    header: "Sign",
    fieldType: "text",
    group: "CLIENT",
    size: 50,
  },
  {
    key: "clientDate",
    header: "Date",
    fieldType: "date",
    group: "CLIENT",
    size: 50,
  },

  // { key: "notes", header: "NOTES", fieldType: "text", size: 75 },
  {
    key: "chat",
    header: "Chat",
    fieldType: "icon",
    Header: () => <ChatIcon />,
    Cell: ({ row }) => (
      <IconButton>
        <ChatIcon />
      </IconButton>
    ),
    size: 50,
  },
  {
    key: "upload",
    header: "doc upload",
    fieldType: "icon",
    Header: () => <CloudUploadIcon />,
    Cell: ({ row }) => (
      <IconButton>
        <CloudUploadIcon />
      </IconButton>
    ),
    size: 50,
  },
];
